const hexToHSL = (H, V) => {
    // this function is only used in browsers that do not yet support the css color-mix function
    // Convert hex to RGB first
    let r = 0,
        g = 0,
        b = 0;
    if (H.length == 4) {
        r = '0x' + H[1] + H[1];
        g = '0x' + H[2] + H[2];
        b = '0x' + H[3] + H[3];
    } else if (H.length == 7) {
        r = '0x' + H[1] + H[2];
        g = '0x' + H[3] + H[4];
        b = '0x' + H[5] + H[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b),
        cmax = Math.max(r, g, b),
        delta = cmax - cmin,
        h = 0,
        s = 0,
        l = 0;

    if (delta == 0) h = 0;
    else if (cmax == r) h = ((g - b) / delta) % 6;
    else if (cmax == g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;

    h = Math.round(h * 60);

    if (h < 0) h += 360;

    l = (cmax + cmin) / 2;
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);

    let headTag = document.getElementsByTagName('head')[0];
    let styleTag = document.createElement("style");
    let primaryValues = ``;
    let secondaryValues = ``;

    if (V === 1) {
        primaryValues = `
            --hue: ${h}deg;
            --sat: ${s}%;
            --light: ${l}%;
        `;
    } else {
        secondaryValues = `
            --sec-hue: ${h}deg;
            --sec-sat: ${s}%;
            --sec-light: ${l}%;
        `;
    }

    styleTag.innerHTML = `
        :root {
            ${primaryValues}
            ${secondaryValues}
        }
    `;
    headTag.appendChild(styleTag);
};

const applyTheming = () => {
    if (document.querySelector('.primary-theme')) {
        const primaryThemeValue = document.querySelector('.primary-theme').dataset.primaryTheme;
        const secondaryThemeValue = document.querySelector('.secondary-theme').dataset.secondaryTheme;
        const fontFamilyValue = document.querySelector('.font-theme').dataset.fontTheme;
        // hexToHSL is only required if browsers cannot use color-mix CSS function, which does the job without the need for JS.
        if (!CSS.supports('color: color-mix(in srgb, white, black)')) {
            hexToHSL(primaryThemeValue, 1);
            hexToHSL(secondaryThemeValue, 2);
        }
    
        let headTag = document.getElementsByTagName('head')[0];
        let styleTag = document.createElement("style");
    
        styleTag.innerHTML = `
            :root {
                ${ primaryThemeValue && primaryThemeValue !=="" ? `--primary-theme-color: ${primaryThemeValue}` : ``};
                ${ secondaryThemeValue && secondaryThemeValue !=="" ? `--secondary-theme-color: ${secondaryThemeValue}` : ``};
                ${ fontFamilyValue && fontFamilyValue !=="" ? `--font-family-theme: ${fontFamilyValue}` : ``};
            }
        `;
        headTag.appendChild(styleTag);
    }
};

document.addEventListener('DOMContentLoaded', applyTheming);